import { i18n } from 'i18n';
import {
  BinderCostRecordDto,
  BinderCostRecordForm,
  PagedListOfBinderCostRecordDto
} from './api';
import {
  makeCreateMutation,
  makeGetQuery,
  makeListQuery,
  makeUpdateMutation,
  PageParams
} from './useApi';

const BINDER_COST_RECORDS_KEY = 'binder-cost-records';
const BINDER_COST_RECORD_KEY = 'binder-cost-record';
export interface BinderCostRecordSearchParams extends PageParams {
  projectId: string;
  brand?: string | null;
  supplier?: string | null;
  purchaseDateFrom?: string | null;
  purchaseDateTo?: string | null;
  minPricePerTonne?: number | null;
  maxPricePerTonne?: number | null;
}

export const useSearchBinderCostRecordsQuery = makeListQuery<BinderCostRecordSearchParams, PagedListOfBinderCostRecordDto>(
  BINDER_COST_RECORDS_KEY,
  (api, params) => () => api.binderCostRecords.searchBinderCostRecords(
    params.projectId,
    params.page,
    params.pageSize,
    params.brand,
    params.supplier,
    params.purchaseDateFrom,
    params.purchaseDateTo,
    params.minPricePerTonne,
    params.maxPricePerTonne,
  ),
);

export const useBinderCostRecordQuery = makeGetQuery<BinderCostRecordDto, string>(
  BINDER_COST_RECORD_KEY,
  (api, entityId) => () => api.binderCostRecords.get(entityId),
);

export interface CreateBinderCostRecordParams {
  binderCostRecordForm: BinderCostRecordForm
  projectId: string,
}

export const useCreateBinderCostRecordMutation = makeCreateMutation<string, CreateBinderCostRecordParams>(
  BINDER_COST_RECORDS_KEY,
  (api) => (binderCostRecordParams) => api.binderCostRecords.create(binderCostRecordParams.projectId, binderCostRecordParams.binderCostRecordForm),
  () => i18n._('A new binder cost record was successfully created'),
);

export const useUpdateBinderCostRecordMutation = makeUpdateMutation<void, BinderCostRecordForm>(
  BINDER_COST_RECORD_KEY,
  BINDER_COST_RECORDS_KEY,
  (api, entityId) => (form) => api.binderCostRecords.update(entityId, form),
  () => i18n._('Successfully updated the Binder Cost Record'),
);
